const LAYOUT_VERSION = {
  new: 'new',
  legacy: 'legacy',
} as const

export type LayoutVersion = typeof LAYOUT_VERSION[keyof typeof LAYOUT_VERSION]

export function useLayoutVersion() {
  const { feature } = useCountryConfig()
  const version = useCookie<LayoutVersion>('layout-version', {
    default: () => LAYOUT_VERSION.legacy,
  })

  const isNew = computed({
    get: () => Boolean(feature.displayLayoutVersionToggle && version.value === LAYOUT_VERSION.new),
    set: (value: boolean) => {
      version.value = value ? LAYOUT_VERSION.new : LAYOUT_VERSION.legacy
    },
  })

  return { version, isNew }
}
